export default __webpack_public_path__ + "static/media/map_pin_bymelding_fra_publikum_under_behandling.8fcda891.svg";